import { render, staticRenderFns } from "./PDialog.vue?vue&type=template&id=c93c8e64&scoped=true"
import script from "./PDialog.vue?vue&type=script&lang=js"
export * from "./PDialog.vue?vue&type=script&lang=js"
import style0 from "./PDialog.vue?vue&type=style&index=0&id=c93c8e64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c93c8e64",
  null
  
)

export default component.exports